const WEBSITE_PATH = "/website";
const BANNER_PATH = "store-front";
const CONTACT_PATH = "contact";
const KASPERSKY_PATH = "kaspersky";
const LICENSE_KEY_PATH = "license-key";

export const website = [
  //banner 
  {
    name: "Banner List",
    type: "list",
    slug: `${WEBSITE_PATH}/${BANNER_PATH}/banner-list`,
  },
  {
    name: "Banner Detail",
    type: "detail",
    slug: `${WEBSITE_PATH}/${BANNER_PATH}/banner-list`,
  },
  {
    name: "Create Banner",
    type: "create",
    slug: `${WEBSITE_PATH}/${BANNER_PATH}/banner-list`,
  },
  {
    name: "Edit Banner",
    type: "edit",
    slug: `${WEBSITE_PATH}/${BANNER_PATH}/banner-list`,
  },
  //support
  {
    name: "Contact List",
    type: "list",
    slug: `${WEBSITE_PATH}/support/${CONTACT_PATH}`,
  },
  {
    name: "Contact Detail",
    type: "detail",
    slug: `${WEBSITE_PATH}/support/${CONTACT_PATH}`,
  },
  // kaspersky / license key
  {
    name: "License Key List",
    type: "list",
    slug: `${WEBSITE_PATH}/${KASPERSKY_PATH}/${LICENSE_KEY_PATH}`,
  },
  {
    name: "License Key Detail",
    type: "detail",
    slug: `${WEBSITE_PATH}/${KASPERSKY_PATH}/${LICENSE_KEY_PATH}`,
  },
  {
    name: "Create License Key",
    type: "create",
    slug: `${WEBSITE_PATH}/${KASPERSKY_PATH}/${LICENSE_KEY_PATH}`,
  },
  {
    name: "Edit License Key",
    type: "edit",
    slug: `${WEBSITE_PATH}/${KASPERSKY_PATH}/${LICENSE_KEY_PATH}`,
  },
];
